/* Basic Musthaves — verlanglijst (client-side, localStorage).
   Hartjes (product-kaart + PDP) togglen; header-badge telt; /pages/verlanglijst rendert. */
(function () {
  var KEY = 'mts_wishlist_v1';
  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function write(list) { localStorage.setItem(KEY, JSON.stringify(list)); document.dispatchEvent(new CustomEvent('mts:wishlist')); }
  function has(handle) { return read().some(function (i) { return i.handle === handle; }); }
  function toggle(item) {
    var list = read(); var i = list.findIndex(function (x) { return x.handle === item.handle; });
    if (i >= 0) list.splice(i, 1); else list.unshift(item);
    write(list); return i < 0; // true = toegevoegd
  }
  function remove(handle) { write(read().filter(function (i) { return i.handle !== handle; })); }

  function money(cents) { return '€' + (cents / 100).toFixed(2).replace('.', ','); }

  function updateBadge() {
    var n = read().length;
    document.querySelectorAll('[data-mts-wish-badge]').forEach(function (b) {
      b.textContent = n; b.hidden = n === 0;
    });
  }
  function markButtons() {
    document.querySelectorAll('[data-mts-wish]').forEach(function (btn) {
      var on = has(btn.getAttribute('data-mts-wish'));
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? 'Uit verlanglijst verwijderen' : 'Aan verlanglijst toevoegen');
    });
  }

  function wire() {
    document.querySelectorAll('[data-mts-wish]').forEach(function (btn) {
      if (btn.__mtsWired) return; btn.__mtsWired = true;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        toggle({
          handle: btn.getAttribute('data-mts-wish'),
          title: btn.getAttribute('data-mts-wish-title') || '',
          image: btn.getAttribute('data-mts-wish-image') || '',
          price: parseInt(btn.getAttribute('data-mts-wish-price') || '0', 10),
          url: btn.getAttribute('data-mts-wish-url') || ('/products/' + btn.getAttribute('data-mts-wish'))
        });
      });
    });
  }

  // Verlanglijst-pagina renderen
  function renderPage() {
    var root = document.querySelector('[data-mts-wishlist-page]');
    if (!root) return;
    var list = read();
    var grid = root.querySelector('[data-mts-wishlist-grid]');
    var empty = root.querySelector('[data-mts-wishlist-empty]');
    if (!list.length) { if (empty) empty.hidden = false; if (grid) grid.innerHTML = ''; return; }
    if (empty) empty.hidden = true;
    grid.innerHTML = list.map(function (i) {
      return '<div class="mts-card"><div class="mts-card-media">' +
        '<a href="' + i.url + '" aria-label="' + (i.title || '').replace(/"/g, '&quot;') + '">' +
        (i.image ? '<img src="' + i.image + '" alt="" width="600" height="600" loading="lazy">' : '<span class="mts-ph">geen foto</span>') +
        '</a>' +
        '<button class="mts-card-wish is-active" type="button" data-mts-wish="' + i.handle + '" aria-label="Uit verlanglijst verwijderen">' +
        '<svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" stroke="currentColor" stroke-width="1.6"><path d="M12 21s-7-4.5-9.5-9C.5 8 3 4 6.5 4c2 0 3.5 1.2 5.5 3.5C13.5 5.2 15.5 4 17.5 4 21 4 23.5 8 21.5 12 19 16.5 12 21 12 21z"/></svg></button>' +
        '</div><div class="mts-card-body">' +
        '<a href="' + i.url + '" class="mts-card-title">' + (i.title || '') + '</a>' +
        '<div class="mts-card-prices"><span class="mts-card-price">' + money(i.price) + '</span></div>' +
        '</div></div>';
    }).join('');
    // remove-knoppen in de grid
    grid.querySelectorAll('[data-mts-wish]').forEach(function (btn) {
      btn.addEventListener('click', function (e) { e.preventDefault(); remove(btn.getAttribute('data-mts-wish')); });
    });
  }

  function refresh() { updateBadge(); markButtons(); renderPage(); }
  document.addEventListener('mts:wishlist', refresh);
  document.addEventListener('DOMContentLoaded', function () { wire(); refresh(); });
  // ook direct (script staat onderaan / defer)
  wire(); refresh();
})();
